export enum CheckboxState {
    Unchecked,
    Checked,
    Indeterminate
}
